import React from 'react';
import { Button, Label, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue, } from '@cargomatic/ui';
import { Trash } from 'lucide-react';
import FormGrid from './FormGrid';
const orderTypes = [
    {
        name: 'Domestic',
        value: 'domestic',
    },
    {
        name: 'Import',
        value: 'import',
    },
    {
        name: 'Export',
        value: 'export',
    },
    {
        name: 'Reposition',
        value: 'reposition',
    },
];
export default function OrderTypeRateConditionField({ condition, onChange, onRemove, }) {
    const { criteria: value } = condition;
    function handleRemove() {
        onRemove(condition);
    }
    function handleChange(criteria) {
        onChange(Object.assign(Object.assign({}, condition), { criteria }));
    }
    return (React.createElement(FormGrid, null,
        React.createElement(Label, { className: "w-48" }, "Order Type"),
        React.createElement(Select, { className: "flex-1", value: value, onValueChange: handleChange },
            React.createElement(SelectTrigger, { className: "" },
                React.createElement(SelectValue, { placeholder: "Order Type" })),
            React.createElement(SelectContent, null,
                React.createElement(SelectGroup, null,
                    React.createElement(SelectLabel, null, "Order Type"),
                    orderTypes.map((orderType) => (React.createElement(SelectItem, { value: orderType.value, key: orderType.value }, orderType.name)))))),
        React.createElement("div", null,
            React.createElement(Button, { variant: "icon", onClick: handleRemove },
                React.createElement(Trash, { className: "w-3.5 h-3.5" })))));
}
